import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { Document, ErrorMessage, IssuedDocumentCreate } from 'types';
import { client } from 'utils/api-client';

export default function useCreateIssuedDocument(): UseMutationResult<
  AxiosResponse<Document>,
  AxiosError<ErrorMessage>,
  IssuedDocumentCreate
> {
  const queryClient = useQueryClient();

  const createIssuedDocument = (document: IssuedDocumentCreate): Promise<AxiosResponse<Document>> => {
    return client.post(`documents/issued/`, document);
  };

  return useMutation(createIssuedDocument, {
    onSuccess: () => {
      queryClient.invalidateQueries('documents');
    },
  });
}
